<div class="ea-loan-amortization" [class.is-compact]="compact">
  <pr-table
    [headerTitle]="headerTitle"
    [tableData]="tableData"
    [sortable]="false"
    [swiperMinWidth]="cardModeMinWidth"
    [swiperConfig]="cardSwiperConfig"
    [showLoader]="loading"
    [rowClass]="resolveRowClass"
    [dense]="compact"
  >
    <pr-radio
      tableHeaderRight
      [hidden]="!hasRows"
      [choices]="viewChoices"
      (onSelectChoice)="onViewChange($event)"
    ></pr-radio>
    <h4 class="semi-bold" emptyTemplate>{{ emptyMessage }}</h4>
  </pr-table>

  @if (view === 'monthly' && totalPages > 1) {
    <div #pagination class="ea-loan-amortization-pagination">
      <pr-pagination
        [current]="currentPage"
        [total]="totalPages"
        (goTo)="onGoTo($event)"
        (next)="onNext($event)"
        (previous)="onPrevious($event)"
      ></pr-pagination>
    </div>
  }

  @if (hasRows && compact) {
    <p class="ea-loan-amortization-breakdown">
      Dont capital
      <strong>{{ totals.capital | currency: 'EUR' : 'symbol' : '.0-2' }}</strong>
      · intérêts
      <strong>{{ totals.interest | currency: 'EUR' : 'symbol' : '.0-2' }}</strong>
      · assurance
      <strong>{{ totals.insurance | currency: 'EUR' : 'symbol' : '.0-2' }}</strong>
    </p>
  }

  @if (showLegend) {
    <ul class="ea-loan-amortization-legend">
      @if (hasBoundaries) {
        <li>
          <span
            class="legend-swatch legend-swatch-boundary"
            aria-hidden="true"
          ></span>
          Nouveau palier (marche)
        </li>
      }
      @if (hasDiffere) {
        <li>
          <span
            class="legend-swatch legend-swatch-differe"
            aria-hidden="true"
          ></span>
          Différé
        </li>
      }
    </ul>
  }
</div>
